module.exports = __webpack_public_path__ + "img/Allec-New-Logo-A.687bd8cc.png";